module.exports = __webpack_public_path__ + "files/b0d80e0fbad86c1c1454f8f2b4ab7a8d.png";